// Globals
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { StyledCard, StyledCardBody, StyledCardHeader, StyledCardTitle } from '../Styled';
import { StyledSummary } from './ConversationSummaryCardStyles';

type TConversationSummaryCardProps = {
  summary?: string;
};

const ConversationSummaryCard: FC<TConversationSummaryCardProps> = ({ summary }) => {
  const { t } = useTranslation();

  return (
    <StyledCard>
      <StyledCardHeader>
        <StyledCardTitle>{t('conversation_summary_title')}</StyledCardTitle>
      </StyledCardHeader>
      <StyledCardBody>
        <StyledSummary $isEmpty={!summary}>{summary || t('conversation_summary_empty')}</StyledSummary>
      </StyledCardBody>
    </StyledCard>
  );
};

export default ConversationSummaryCard;
